var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.25C4.32174 5.25 3.4315 5.61875 2.77513 6.27513C2.11875 6.9315 1.75 7.82174 1.75 8.75V19.25C1.75 20.1783 2.11875 21.0685 2.77513 21.7249C3.4315 22.3813 4.32174 22.75 5.25 22.75H14.875C15.8033 22.75 16.6935 22.3813 17.3499 21.7249C18.0063 21.0685 18.375 20.1783 18.375 19.25V8.75C18.375 7.82174 18.0063 6.9315 17.3499 6.27513C16.6935 5.61875 15.8033 5.25 14.875 5.25H5.25ZM23.2633 21.875L20.125 18.7367V9.26333L23.2633 6.125C24.3647 5.0225 26.25 5.803 26.25 7.36167V20.6383C26.25 22.197 24.3647 22.9775 23.2633 21.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.cea835e81308972e66aecd88fda98971.svg";
export { ForwardRef as ReactComponent };